/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSubuserRequest } from '../models/CreateSubuserRequest';
import type { DeleteSubuserRequest } from '../models/DeleteSubuserRequest';
import type { ResendInvitationRequest } from '../models/ResendInvitationRequest';
import type { SubuserView } from '../models/SubuserView';
import type { SuccessView } from '../models/SuccessView';
import type { UpdateSubuserRequest } from '../models/UpdateSubuserRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubusersService {
    /**
     * Get subusers for current user
     * @returns SubuserView List of subusers
     * @throws ApiError
     */
    public static getAppSubuserList(): CancelablePromise<Array<SubuserView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/subusers',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Update subuser permissions (full replace)
     * @param requestBody
     * @returns SubuserView Subuser permissions updated
     * @throws ApiError
     */
    public static putAppSubuserUpdate(
        requestBody: UpdateSubuserRequest,
    ): CancelablePromise<SubuserView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/user/subusers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error (unknown permission key, etc.)`,
                403: `Caller is not the account owner`,
                404: `Subuser not found`,
            },
        });
    }
    /**
     * Create subuser for current user
     * @param requestBody
     * @returns SubuserView Subuser created
     * @throws ApiError
     */
    public static postAppSubuserCreate(
        requestBody: CreateSubuserRequest,
    ): CancelablePromise<SubuserView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/subusers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Delete subuser for current user
     * @param requestBody
     * @returns any Subuser deleted
     * @throws ApiError
     */
    public static deleteAppSubuserDelete(
        requestBody: DeleteSubuserRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/user/subusers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Subuser not found`,
            },
        });
    }
    /**
     * Get max allowed subusers for current user
     * @returns any Max allowed subusers count
     * @throws ApiError
     */
    public static getAppSubuserMaxAllowed(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/subusers/max-allowed',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Resend invitation email to subuser
     * @param requestBody
     * @returns SuccessView Invitation resent
     * @throws ApiError
     */
    public static postAppSubuserResendInvitation(
        requestBody: ResendInvitationRequest,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/subusers/resend-invitation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error (e.g., account already activated)`,
                404: `Subuser not found`,
            },
        });
    }
}
